// Protocol Buffers схема для Poller Service
// Согласно: инструкции/06-BACKEND_МИГРАЦИЯ/PROTOBUF_И_GRPC.md
// Конвертировано из Pydantic моделей (microservice/poller/src/schemas.py)

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none"
// @generated from file poller/v1/poller.proto (package poller.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { OnuDeregReason, OnuInfo, OnuInterface, OnuMeasurement } from "./pollers_pb";
import { file_poller_v1_pollers } from "./pollers_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file poller/v1/poller.proto.
 */
export const file_poller_v1_poller: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_struct, file_google_protobuf_timestamp, file_poller_v1_pollers]);

/**
 * Poller Task (для RabbitMQ)
 *
 * @generated from message poller.v1.PollerTask
 */
export type PollerTask = Message<"poller.v1.PollerTask"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * IfList, FdbTable, OnuList, etc.
   *
   * @generated from field: string task_name = 2;
   */
  taskName: string;

  /**
   * @generated from field: poller.v1.PollerDevice device = 3;
   */
  device?: PollerDevice | undefined;

  /**
   * @generated from field: google.protobuf.Struct payload = 4;
   */
  payload?: JsonObject | undefined;

  /**
   * @generated from field: int32 priority = 5;
   */
  priority: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;

  /**
   * для multi-region support
   *
   * @generated from field: string satellite_id = 7;
   */
  satelliteId: string;
};

/**
 * Describes the message poller.v1.PollerTask.
 * Use `create(PollerTaskSchema)` to create a new message.
 */
export const PollerTaskSchema: GenMessage<PollerTask> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 0);

/**
 * Device для Poller (упрощенная версия)
 *
 * @generated from message poller.v1.PollerDevice
 */
export type PollerDevice = Message<"poller.v1.PollerDevice"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string host = 2;
   */
  host: string;

  /**
   * SNMP settings
   *
   * @generated from field: int32 snmp_port = 3;
   */
  snmpPort: number;

  /**
   * @generated from field: string snmp_community = 4;
   */
  snmpCommunity: string;

  /**
   * "1", "2c", "3"
   *
   * @generated from field: string snmp_version = 5;
   */
  snmpVersion: string;

  /**
   * SNMP v3
   *
   * @generated from field: string snmp_v3_security_name = 6;
   */
  snmpV3SecurityName: string;

  /**
   * @generated from field: string snmp_v3_sec_level = 7;
   */
  snmpV3SecLevel: string;

  /**
   * @generated from field: string snmp_v3_auth_protocol = 8;
   */
  snmpV3AuthProtocol: string;

  /**
   * @generated from field: string snmp_v3_auth_passphrase = 9;
   */
  snmpV3AuthPassphrase: string;

  /**
   * @generated from field: string snmp_v3_priv_protocol = 10;
   */
  snmpV3PrivProtocol: string;

  /**
   * @generated from field: string snmp_v3_priv_passphrase = 11;
   */
  snmpV3PrivPassphrase: string;

  /**
   * Telnet settings
   *
   * @generated from field: string telnet_username = 12;
   */
  telnetUsername: string;

  /**
   * @generated from field: string telnet_password = 13;
   */
  telnetPassword: string;

  /**
   * @generated from field: string telnet_enable_password = 14;
   */
  telnetEnablePassword: string;

  /**
   * @generated from field: int32 telnet_port = 15;
   */
  telnetPort: number;

  /**
   * Device metadata
   *
   * @generated from field: string vendor = 16;
   */
  vendor: string;

  /**
   * @generated from field: string model = 17;
   */
  model: string;

  /**
   * Категория оборудования из БД: "0"=SOHO (customer), "1"=Managed/Router (customer), "2"=ONU, "3"=OLT, "4"=SOHO (device), "5"=Managed (device), ""=Router/Switch
   *
   * @generated from field: string equipment_cat = 21;
   */
  equipmentCat: string;

  /**
   * seconds
   *
   * @generated from field: int32 timeout = 18;
   */
  timeout: number;

  /**
   * @generated from field: int32 retries = 19;
   */
  retries: number;

  /**
   * Behaviors (какие task поддерживает)
   *
   * @generated from field: poller.v1.Behaviors behaviors = 20;
   */
  behaviors?: Behaviors | undefined;
};

/**
 * Describes the message poller.v1.PollerDevice.
 * Use `create(PollerDeviceSchema)` to create a new message.
 */
export const PollerDeviceSchema: GenMessage<PollerDevice> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 1);

/**
 * Behaviors (поддержка различных типов опроса)
 *
 * @generated from message poller.v1.Behaviors
 */
export type Behaviors = Message<"poller.v1.Behaviors"> & {
  /**
   * Interface poller behavior
   *
   * @generated from field: string iface = 1;
   */
  iface: string;

  /**
   * PON poller behavior
   *
   * @generated from field: string pon = 2;
   */
  pon: string;

  /**
   * FDB poller behavior
   *
   * @generated from field: string fdb = 3;
   */
  fdb: string;

  /**
   * ARP poller behavior
   *
   * @generated from field: string arp = 4;
   */
  arp: string;

  /**
   * VLAN poller behavior
   *
   * @generated from field: string vlan = 5;
   */
  vlan: string;

  /**
   * Cable Test behavior
   *
   * @generated from field: string tdr = 6;
   */
  tdr: string;

  /**
   * Radio poller behavior
   *
   * @generated from field: string radio = 7;
   */
  radio: string;
};

/**
 * Describes the message poller.v1.Behaviors.
 * Use `create(BehaviorsSchema)` to create a new message.
 */
export const BehaviorsSchema: GenMessage<Behaviors> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 2);

/**
 * Poller Result
 *
 * @generated from message poller.v1.PollerResult
 */
export type PollerResult = Message<"poller.v1.PollerResult"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string task_name = 2;
   */
  taskName: string;

  /**
   * @generated from field: poller.v1.PollerResult.ResultStatus status = 3;
   */
  status: PollerResult_ResultStatus;

  /**
   * @generated from field: poller.v1.PollerDevice device = 4;
   */
  device?: PollerDevice | undefined;

  /**
   * Results (oneof для разных типов)
   *
   * @generated from field: repeated poller.v1.Interface interfaces = 5;
   */
  interfaces: Interface[];

  /**
   * @generated from field: repeated poller.v1.ONU onus = 6;
   */
  onus: ONU[];

  /**
   * @generated from field: repeated poller.v1.FDBEntry fdb_entries = 7;
   */
  fdbEntries: FDBEntry[];

  /**
   * @generated from field: repeated poller.v1.ARPEntry arp_entries = 8;
   */
  arpEntries: ARPEntry[];

  /**
   * @generated from field: repeated poller.v1.VLANEntry vlan_entries = 9;
   */
  vlanEntries: VLANEntry[];

  /**
   * @generated from field: poller.v1.CableTestResult cable_test = 10;
   */
  cableTest?: CableTestResult | undefined;

  /**
   * @generated from field: repeated poller.v1.RadioPeer radio_peers = 11;
   */
  radioPeers: RadioPeer[];

  /**
   * Error (если есть)
   *
   * @generated from field: poller.v1.PollerError error = 12;
   */
  error?: PollerError | undefined;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp started_at = 13;
   */
  startedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 14;
   */
  finishedAt?: Timestamp | undefined;

  /**
   * @generated from field: repeated poller.v1.SnmpReadResult snmp_results = 15;
   */
  snmpResults: SnmpReadResult[];

  /**
   * @generated from field: poller.v1.PingResult ping = 16;
   */
  ping?: PingResult | undefined;

  /**
   * @generated from field: poller.v1.PonResult pon = 17;
   */
  pon?: PonResult | undefined;

  /**
   * Только для локально структурно проверенного VLAN-снимка с раздельными
   * tagged/untagged ifIndex. Не доказывает владельца, свежесть или абсолютную
   * полноту Walk; старые отправители не заполняют этот признак.
   *
   * @generated from field: bool vlan_snapshot_structurally_validated = 18;
   */
  vlanSnapshotStructurallyValidated: boolean;

  /**
   * Полный набор портов CableTest. Старое cable_test сохраняет первый порт
   * для обратной совместимости; потребитель нового wire читает cable_tests.
   *
   * @generated from field: repeated poller.v1.CableTestResult cable_tests = 19;
   */
  cableTests: CableTestResult[];

  /**
   * Истина только после завершения всех запрошенных портов; различает
   * корректный пустой выбор и старый producer без batch-контракта.
   *
   * @generated from field: bool cable_test_selection_complete = 20;
   */
  cableTestSelectionComplete: boolean;
};

/**
 * Describes the message poller.v1.PollerResult.
 * Use `create(PollerResultSchema)` to create a new message.
 */
export const PollerResultSchema: GenMessage<PollerResult> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 3);

/**
 * @generated from enum poller.v1.PollerResult.ResultStatus
 */
export enum PollerResult_ResultStatus {
  /**
   * @generated from enum value: RESULT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESULT_STATUS_OK = 1;
   */
  OK = 1,

  /**
   * @generated from enum value: RESULT_STATUS_ERROR = 2;
   */
  ERROR = 2,

  /**
   * @generated from enum value: RESULT_STATUS_TIMEOUT = 3;
   */
  TIMEOUT = 3,

  /**
   * Задача не поддерживается этим оборудованием.
   *
   * ВАЖНО: это НЕ отказ устройства. Живой замер стенда (2026-09-23): у `wnm_pon` три OLT из
   * девяти «отказывали» только потому, что у их поведения нет драйвера для OltRxPower и
   * OltTxPower. Прогон модуля от этого уходил в `partial`, а оператор читал это как поломку
   * железа. Добавление значения аддитивно: старые потребители видят неизвестный номер и
   * трактуют его как UNSPECIFIED, ломающего переименования нет.
   *
   * @generated from enum value: RESULT_STATUS_NOT_SUPPORTED = 4;
   */
  NOT_SUPPORTED = 4,
}

/**
 * Describes the enum poller.v1.PollerResult.ResultStatus.
 */
export const PollerResult_ResultStatusSchema: GenEnum<PollerResult_ResultStatus> = /*@__PURE__*/
  enumDesc(file_poller_v1_poller, 3, 0);

/**
 * Interface (результат IfList, IfTraffic)
 *
 * @generated from message poller.v1.Interface
 */
export type Interface = Message<"poller.v1.Interface"> & {
  /**
   * @generated from field: int32 index = 1;
   */
  index: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: poller.v1.Interface.InterfaceStatus admin_status = 4;
   */
  adminStatus: Interface_InterfaceStatus;

  /**
   * @generated from field: poller.v1.Interface.InterfaceStatus oper_status = 5;
   */
  operStatus: Interface_InterfaceStatus;

  /**
   * bps
   *
   * @generated from field: int64 speed = 6;
   */
  speed: bigint;

  /**
   * @generated from field: int32 mtu = 7;
   */
  mtu: number;

  /**
   * @generated from field: int32 type = 8;
   */
  type: number;

  /**
   * Traffic
   *
   * @generated from field: uint64 in_octets = 9;
   */
  inOctets: bigint;

  /**
   * @generated from field: uint64 out_octets = 10;
   */
  outOctets: bigint;

  /**
   * @generated from field: uint64 in_errors = 11;
   */
  inErrors: bigint;

  /**
   * @generated from field: uint64 out_errors = 12;
   */
  outErrors: bigint;

  /**
   * @generated from field: uint64 in_discards = 13;
   */
  inDiscards: bigint;

  /**
   * @generated from field: uint64 out_discards = 14;
   */
  outDiscards: bigint;

  /**
   * @generated from field: uint64 in_ucast_pkts = 15;
   */
  inUcastPkts: bigint;

  /**
   * @generated from field: uint64 out_ucast_pkts = 16;
   */
  outUcastPkts: bigint;

  /**
   * MAC address
   *
   * @generated from field: string phys_address = 17;
   */
  physAddress: string;

  /**
   * Last change
   *
   * @generated from field: int64 last_change = 18;
   */
  lastChange: bigint;

  /**
   * Additional metadata
   *
   * @generated from field: bool connector_present = 19;
   */
  connectorPresent: boolean;

  /**
   * @generated from field: string alias = 20;
   */
  alias: string;
};

/**
 * Describes the message poller.v1.Interface.
 * Use `create(InterfaceSchema)` to create a new message.
 */
export const InterfaceSchema: GenMessage<Interface> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 4);

/**
 * @generated from enum poller.v1.Interface.InterfaceStatus
 */
export enum Interface_InterfaceStatus {
  /**
   * @generated from enum value: INTERFACE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTERFACE_STATUS_UP = 1;
   */
  UP = 1,

  /**
   * @generated from enum value: INTERFACE_STATUS_DOWN = 2;
   */
  DOWN = 2,

  /**
   * @generated from enum value: INTERFACE_STATUS_TESTING = 3;
   */
  TESTING = 3,
}

/**
 * Describes the enum poller.v1.Interface.InterfaceStatus.
 */
export const Interface_InterfaceStatusSchema: GenEnum<Interface_InterfaceStatus> = /*@__PURE__*/
  enumDesc(file_poller_v1_poller, 4, 0);

/**
 * ONU (PON результаты)
 *
 * @generated from message poller.v1.ONU
 */
export type ONU = Message<"poller.v1.ONU"> & {
  /**
   * @generated from field: string frame = 1;
   */
  frame: string;

  /**
   * @generated from field: string slot = 2;
   */
  slot: string;

  /**
   * @generated from field: string port = 3;
   */
  port: string;

  /**
   * @generated from field: string onu_id = 4;
   */
  onuId: string;

  /**
   * @generated from field: string serial = 5;
   */
  serial: string;

  /**
   * @generated from field: string name = 6;
   */
  name: string;

  /**
   * @generated from field: string vendor = 7;
   */
  vendor: string;

  /**
   * @generated from field: string model = 8;
   */
  model: string;

  /**
   * @generated from field: poller.v1.ONU.ONUStatus status = 9;
   */
  status: ONU_ONUStatus;

  /**
   * Optical parameters
   *
   * @generated from field: poller.v1.OpticalParams optical = 10;
   */
  optical?: OpticalParams | undefined;

  /**
   * Additional info
   *
   * meters
   *
   * @generated from field: int32 distance = 11;
   */
  distance: number;

  /**
   * @generated from field: string firmware = 12;
   */
  firmware: string;

  /**
   * @generated from field: string hardware = 13;
   */
  hardware: string;

  /**
   * @generated from field: string description = 14;
   */
  description: string;
};

/**
 * Describes the message poller.v1.ONU.
 * Use `create(ONUSchema)` to create a new message.
 */
export const ONUSchema: GenMessage<ONU> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 5);

/**
 * @generated from enum poller.v1.ONU.ONUStatus
 */
export enum ONU_ONUStatus {
  /**
   * @generated from enum value: ONU_STATUS_UNSPECIFIED = 0;
   */
  ONU_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ONU_STATUS_ONLINE = 1;
   */
  ONU_STATUS_ONLINE = 1,

  /**
   * @generated from enum value: ONU_STATUS_OFFLINE = 2;
   */
  ONU_STATUS_OFFLINE = 2,

  /**
   * @generated from enum value: ONU_STATUS_DYING_GASP = 3;
   */
  ONU_STATUS_DYING_GASP = 3,

  /**
   * @generated from enum value: ONU_STATUS_LOS = 4;
   */
  ONU_STATUS_LOS = 4,
}

/**
 * Describes the enum poller.v1.ONU.ONUStatus.
 */
export const ONU_ONUStatusSchema: GenEnum<ONU_ONUStatus> = /*@__PURE__*/
  enumDesc(file_poller_v1_poller, 5, 0);

/**
 * Optical Parameters
 *
 * @generated from message poller.v1.OpticalParams
 */
export type OpticalParams = Message<"poller.v1.OpticalParams"> & {
  /**
   * dBm
   *
   * @generated from field: double onu_rx_power = 1;
   */
  onuRxPower: number;

  /**
   * dBm
   *
   * @generated from field: double onu_tx_power = 2;
   */
  onuTxPower: number;

  /**
   * dBm
   *
   * @generated from field: double olt_rx_power = 3;
   */
  oltRxPower: number;

  /**
   * dBm
   *
   * @generated from field: double olt_tx_power = 4;
   */
  oltTxPower: number;

  /**
   * meters
   *
   * @generated from field: int32 distance = 5;
   */
  distance: number;

  /**
   * Celsius
   *
   * @generated from field: double temperature = 6;
   */
  temperature: number;

  /**
   * Volts
   *
   * @generated from field: double voltage = 7;
   */
  voltage: number;

  /**
   * mA
   *
   * @generated from field: double bias_current = 8;
   */
  biasCurrent: number;
};

/**
 * Describes the message poller.v1.OpticalParams.
 * Use `create(OpticalParamsSchema)` to create a new message.
 */
export const OpticalParamsSchema: GenMessage<OpticalParams> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 6);

/**
 * PonResult содержит универсальные структуры для задач OnuList/OnuPower/OnuState и т.д.
 *
 * @generated from message poller.v1.PonResult
 */
export type PonResult = Message<"poller.v1.PonResult"> & {
  /**
   * @generated from field: repeated workernet.pollers.OnuInfo onus = 1;
   */
  onus: OnuInfo[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement onu_tx_power = 2;
   */
  onuTxPower: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement onu_rx_power = 3;
   */
  onuRxPower: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement olt_tx_power = 4;
   */
  oltTxPower: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement olt_rx_power = 5;
   */
  oltRxPower: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement distance = 6;
   */
  distance: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement temperature = 7;
   */
  temperature: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuDeregReason dereg_reasons = 8;
   */
  deregReasons: OnuDeregReason[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement state = 9;
   */
  state: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuInterface interfaces = 10;
   */
  interfaces: OnuInterface[];
};

/**
 * Describes the message poller.v1.PonResult.
 * Use `create(PonResultSchema)` to create a new message.
 */
export const PonResultSchema: GenMessage<PonResult> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 7);

/**
 * Snmp Read result
 *
 * @generated from message poller.v1.SnmpReadResult
 */
export type SnmpReadResult = Message<"poller.v1.SnmpReadResult"> & {
  /**
   * @generated from field: string var_bind = 1;
   */
  varBind: string;

  /**
   * @generated from field: string snmp_type = 2;
   */
  snmpType: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message poller.v1.SnmpReadResult.
 * Use `create(SnmpReadResultSchema)` to create a new message.
 */
export const SnmpReadResultSchema: GenMessage<SnmpReadResult> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 8);

/**
 * Ping packets statistics
 *
 * @generated from message poller.v1.Packets
 */
export type Packets = Message<"poller.v1.Packets"> & {
  /**
   * @generated from field: int64 sent = 1;
   */
  sent: bigint;

  /**
   * @generated from field: int64 received = 2;
   */
  received: bigint;

  /**
   * @generated from field: double loss = 3;
   */
  loss: number;
};

/**
 * Describes the message poller.v1.Packets.
 * Use `create(PacketsSchema)` to create a new message.
 */
export const PacketsSchema: GenMessage<Packets> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 9);

/**
 * Ping time round trip measurements
 *
 * @generated from message poller.v1.TRR
 */
export type TRR = Message<"poller.v1.TRR"> & {
  /**
   * @generated from field: double min = 1;
   */
  min: number;

  /**
   * @generated from field: double max = 2;
   */
  max: number;

  /**
   * @generated from field: double avg = 3;
   */
  avg: number;

  /**
   * @generated from field: repeated double all = 4;
   */
  all: number[];

  /**
   * @generated from field: double jitter = 5;
   */
  jitter: number;
};

/**
 * Describes the message poller.v1.TRR.
 * Use `create(TRRSchema)` to create a new message.
 */
export const TRRSchema: GenMessage<TRR> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 10);

/**
 * Ping result payload
 *
 * @generated from message poller.v1.PingResult
 */
export type PingResult = Message<"poller.v1.PingResult"> & {
  /**
   * @generated from field: bool is_alive = 1;
   */
  isAlive: boolean;

  /**
   * @generated from field: poller.v1.Packets packets = 2;
   */
  packets?: Packets | undefined;

  /**
   * @generated from field: poller.v1.TRR trr = 3;
   */
  trr?: TRR | undefined;
};

/**
 * Describes the message poller.v1.PingResult.
 * Use `create(PingResultSchema)` to create a new message.
 */
export const PingResultSchema: GenMessage<PingResult> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 11);

/**
 * FDB Entry
 *
 * @generated from message poller.v1.FDBEntry
 */
export type FDBEntry = Message<"poller.v1.FDBEntry"> & {
  /**
   * @generated from field: string mac_address = 1;
   */
  macAddress: string;

  /**
   * @generated from field: int32 vlan_id = 2;
   */
  vlanId: number;

  /**
   * @generated from field: int32 port = 3;
   */
  port: number;

  /**
   * @generated from field: string port_name = 4;
   */
  portName: string;

  /**
   * @generated from field: poller.v1.FDBEntry.FDBType type = 5;
   */
  type: FDBEntry_FDBType;

  /**
   * @generated from field: int64 date_first = 6;
   */
  dateFirst: bigint;

  /**
   * @generated from field: int64 date_last = 7;
   */
  dateLast: bigint;
};

/**
 * Describes the message poller.v1.FDBEntry.
 * Use `create(FDBEntrySchema)` to create a new message.
 */
export const FDBEntrySchema: GenMessage<FDBEntry> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 12);

/**
 * @generated from enum poller.v1.FDBEntry.FDBType
 */
export enum FDBEntry_FDBType {
  /**
   * @generated from enum value: FDB_TYPE_UNSPECIFIED = 0;
   */
  FDB_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: FDB_TYPE_STATIC = 1;
   */
  FDB_TYPE_STATIC = 1,

  /**
   * @generated from enum value: FDB_TYPE_DYNAMIC = 2;
   */
  FDB_TYPE_DYNAMIC = 2,
}

/**
 * Describes the enum poller.v1.FDBEntry.FDBType.
 */
export const FDBEntry_FDBTypeSchema: GenEnum<FDBEntry_FDBType> = /*@__PURE__*/
  enumDesc(file_poller_v1_poller, 12, 0);

/**
 * ARP Entry
 *
 * @generated from message poller.v1.ARPEntry
 */
export type ARPEntry = Message<"poller.v1.ARPEntry"> & {
  /**
   * @generated from field: string ip_address = 1;
   */
  ipAddress: string;

  /**
   * @generated from field: string mac_address = 2;
   */
  macAddress: string;

  /**
   * @generated from field: int32 vlan_id = 3;
   */
  vlanId: number;

  /**
   * @generated from field: int32 if_index = 4;
   */
  ifIndex: number;

  /**
   * @generated from field: poller.v1.ARPEntry.ARPType type = 5;
   */
  type: ARPEntry_ARPType;
};

/**
 * Describes the message poller.v1.ARPEntry.
 * Use `create(ARPEntrySchema)` to create a new message.
 */
export const ARPEntrySchema: GenMessage<ARPEntry> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 13);

/**
 * @generated from enum poller.v1.ARPEntry.ARPType
 */
export enum ARPEntry_ARPType {
  /**
   * @generated from enum value: ARP_TYPE_UNSPECIFIED = 0;
   */
  ARP_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ARP_TYPE_STATIC = 1;
   */
  ARP_TYPE_STATIC = 1,

  /**
   * @generated from enum value: ARP_TYPE_DYNAMIC = 2;
   */
  ARP_TYPE_DYNAMIC = 2,
}

/**
 * Describes the enum poller.v1.ARPEntry.ARPType.
 */
export const ARPEntry_ARPTypeSchema: GenEnum<ARPEntry_ARPType> = /*@__PURE__*/
  enumDesc(file_poller_v1_poller, 13, 0);

/**
 * VLAN Entry
 *
 * @generated from message poller.v1.VLANEntry
 */
export type VLANEntry = Message<"poller.v1.VLANEntry"> & {
  /**
   * @generated from field: int32 vlan_id = 1;
   */
  vlanId: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: poller.v1.VLANEntry.VLANStatus status = 3;
   */
  status: VLANEntry_VLANStatus;

  /**
   * @generated from field: repeated int32 ports = 4;
   */
  ports: number[];

  /**
   * Аддитивные поля: ports остаётся прежним объединением для старых потребителей.
   *
   * @generated from field: repeated int32 tagged_if_indexes = 5;
   */
  taggedIfIndexes: number[];

  /**
   * @generated from field: repeated int32 untagged_if_indexes = 6;
   */
  untaggedIfIndexes: number[];
};

/**
 * Describes the message poller.v1.VLANEntry.
 * Use `create(VLANEntrySchema)` to create a new message.
 */
export const VLANEntrySchema: GenMessage<VLANEntry> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 14);

/**
 * @generated from enum poller.v1.VLANEntry.VLANStatus
 */
export enum VLANEntry_VLANStatus {
  /**
   * @generated from enum value: VLAN_STATUS_UNSPECIFIED = 0;
   */
  VLAN_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: VLAN_STATUS_ACTIVE = 1;
   */
  VLAN_STATUS_ACTIVE = 1,

  /**
   * @generated from enum value: VLAN_STATUS_SUSPENDED = 2;
   */
  VLAN_STATUS_SUSPENDED = 2,
}

/**
 * Describes the enum poller.v1.VLANEntry.VLANStatus.
 */
export const VLANEntry_VLANStatusSchema: GenEnum<VLANEntry_VLANStatus> = /*@__PURE__*/
  enumDesc(file_poller_v1_poller, 14, 0);

/**
 * Cable Test Result
 *
 * @generated from message poller.v1.CableTestResult
 */
export type CableTestResult = Message<"poller.v1.CableTestResult"> & {
  /**
   * @generated from field: int32 if_index = 1;
   */
  ifIndex: number;

  /**
   * @generated from field: repeated poller.v1.CableTestResult.CablePair pairs = 2;
   */
  pairs: CableTestResult_CablePair[];

  /**
   * Исходный ifOperStatus 1..7; отсутствие совместимо со старыми результатами.
   *
   * @generated from field: optional int32 status_oper = 3;
   */
  statusOper?: number | undefined;
};

/**
 * Describes the message poller.v1.CableTestResult.
 * Use `create(CableTestResultSchema)` to create a new message.
 */
export const CableTestResultSchema: GenMessage<CableTestResult> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 15);

/**
 * @generated from message poller.v1.CableTestResult.CablePair
 */
export type CableTestResult_CablePair = Message<"poller.v1.CableTestResult.CablePair"> & {
  /**
   * @generated from field: int32 pair_number = 1;
   */
  pairNumber: number;

  /**
   * @generated from field: poller.v1.CableTestResult.CablePair.CableStatus status = 2;
   */
  status: CableTestResult_CablePair_CableStatus;

  /**
   * meters
   *
   * @generated from field: int32 length = 3;
   */
  length: number;
};

/**
 * Describes the message poller.v1.CableTestResult.CablePair.
 * Use `create(CableTestResult_CablePairSchema)` to create a new message.
 */
export const CableTestResult_CablePairSchema: GenMessage<CableTestResult_CablePair> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 15, 0);

/**
 * @generated from enum poller.v1.CableTestResult.CablePair.CableStatus
 */
export enum CableTestResult_CablePair_CableStatus {
  /**
   * @generated from enum value: CABLE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CABLE_STATUS_OK = 1;
   */
  OK = 1,

  /**
   * @generated from enum value: CABLE_STATUS_OPEN = 2;
   */
  OPEN = 2,

  /**
   * @generated from enum value: CABLE_STATUS_SHORT = 3;
   */
  SHORT = 3,

  /**
   * @generated from enum value: CABLE_STATUS_CROSSTALK = 4;
   */
  CROSSTALK = 4,
}

/**
 * Describes the enum poller.v1.CableTestResult.CablePair.CableStatus.
 */
export const CableTestResult_CablePair_CableStatusSchema: GenEnum<CableTestResult_CablePair_CableStatus> = /*@__PURE__*/
  enumDesc(file_poller_v1_poller, 15, 0, 0);

/**
 * Radio Peer
 *
 * @generated from message poller.v1.RadioPeer
 */
export type RadioPeer = Message<"poller.v1.RadioPeer"> & {
  /**
   * @generated from field: string mac_address = 1;
   */
  macAddress: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * dBm
   *
   * @generated from field: int32 signal_strength = 3;
   */
  signalStrength: number;

  /**
   * dBm
   *
   * @generated from field: int32 noise_floor = 4;
   */
  noiseFloor: number;

  /**
   * Mbps
   *
   * @generated from field: int32 tx_rate = 5;
   */
  txRate: number;

  /**
   * Mbps
   *
   * @generated from field: int32 rx_rate = 6;
   */
  rxRate: number;

  /**
   * meters
   *
   * @generated from field: int32 distance = 7;
   */
  distance: number;

  /**
   * %
   *
   * @generated from field: double ccq = 8;
   */
  ccq: number;

  /**
   * Аддитивные V4-поля: presence отличает отсутствующий OID от нуля.
   *
   * dB, прямое значение SNMP там, где оно есть
   *
   * @generated from field: optional int32 signal_to_noise = 9;
   */
  signalToNoise?: number | undefined;

  /**
   * целые секунды после перевода TimeTicks / 100
   *
   * @generated from field: optional uint64 uptime_seconds = 10;
   */
  uptimeSeconds?: bigint | undefined;

  /**
   * Mbps с точностью V4 до сотых
   *
   * @generated from field: optional double tx_rate_mbps = 11;
   */
  txRateMbps?: number | undefined;

  /**
   * Mbps с точностью V4 до сотых
   *
   * @generated from field: optional double rx_rate_mbps = 12;
   */
  rxRateMbps?: number | undefined;

  /**
   * bytes
   *
   * @generated from field: optional uint64 traffic_tx_bytes = 13;
   */
  trafficTxBytes?: bigint | undefined;

  /**
   * bytes
   *
   * @generated from field: optional uint64 traffic_rx_bytes = 14;
   */
  trafficRxBytes?: bigint | undefined;

  /**
   * последний известный IP станции (AirMAX)
   *
   * @generated from field: optional string ip_address = 15;
   */
  ipAddress?: string | undefined;
};

/**
 * Describes the message poller.v1.RadioPeer.
 * Use `create(RadioPeerSchema)` to create a new message.
 */
export const RadioPeerSchema: GenMessage<RadioPeer> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 16);

/**
 * @generated from message poller.v1.PollDeviceRequest
 */
export type PollDeviceRequest = Message<"poller.v1.PollDeviceRequest"> & {
  /**
   * @generated from field: string task_name = 1;
   */
  taskName: string;

  /**
   * @generated from field: poller.v1.PollerDevice device = 2;
   */
  device?: PollerDevice | undefined;

  /**
   * @generated from field: google.protobuf.Struct payload = 3;
   */
  payload?: JsonObject | undefined;
};

/**
 * Describes the message poller.v1.PollDeviceRequest.
 * Use `create(PollDeviceRequestSchema)` to create a new message.
 */
export const PollDeviceRequestSchema: GenMessage<PollDeviceRequest> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 17);

/**
 * @generated from message poller.v1.PollDeviceResponse
 */
export type PollDeviceResponse = Message<"poller.v1.PollDeviceResponse"> & {
  /**
   * @generated from field: poller.v1.PollerResult result = 1;
   */
  result?: PollerResult | undefined;
};

/**
 * Describes the message poller.v1.PollDeviceResponse.
 * Use `create(PollDeviceResponseSchema)` to create a new message.
 */
export const PollDeviceResponseSchema: GenMessage<PollDeviceResponse> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 18);

/**
 * @generated from message poller.v1.GetPollResultsRequest
 */
export type GetPollResultsRequest = Message<"poller.v1.GetPollResultsRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;
};

/**
 * Describes the message poller.v1.GetPollResultsRequest.
 * Use `create(GetPollResultsRequestSchema)` to create a new message.
 */
export const GetPollResultsRequestSchema: GenMessage<GetPollResultsRequest> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 19);

/**
 * @generated from message poller.v1.GetPollResultsResponse
 */
export type GetPollResultsResponse = Message<"poller.v1.GetPollResultsResponse"> & {
  /**
   * @generated from field: poller.v1.PollerResult result = 1;
   */
  result?: PollerResult | undefined;
};

/**
 * Describes the message poller.v1.GetPollResultsResponse.
 * Use `create(GetPollResultsResponseSchema)` to create a new message.
 */
export const GetPollResultsResponseSchema: GenMessage<GetPollResultsResponse> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 20);

/**
 * @generated from message poller.v1.GetInterfacesRequest
 */
export type GetInterfacesRequest = Message<"poller.v1.GetInterfacesRequest"> & {
  /**
   * @generated from field: int64 device_id = 1;
   */
  deviceId: bigint;
};

/**
 * Describes the message poller.v1.GetInterfacesRequest.
 * Use `create(GetInterfacesRequestSchema)` to create a new message.
 */
export const GetInterfacesRequestSchema: GenMessage<GetInterfacesRequest> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 21);

/**
 * @generated from message poller.v1.GetInterfacesResponse
 */
export type GetInterfacesResponse = Message<"poller.v1.GetInterfacesResponse"> & {
  /**
   * @generated from field: repeated poller.v1.Interface interfaces = 1;
   */
  interfaces: Interface[];
};

/**
 * Describes the message poller.v1.GetInterfacesResponse.
 * Use `create(GetInterfacesResponseSchema)` to create a new message.
 */
export const GetInterfacesResponseSchema: GenMessage<GetInterfacesResponse> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 22);

/**
 * @generated from message poller.v1.GetFDBRequest
 */
export type GetFDBRequest = Message<"poller.v1.GetFDBRequest"> & {
  /**
   * @generated from field: int64 device_id = 1;
   */
  deviceId: bigint;

  /**
   * optional filter
   *
   * @generated from field: int32 vlan_id = 2;
   */
  vlanId: number;
};

/**
 * Describes the message poller.v1.GetFDBRequest.
 * Use `create(GetFDBRequestSchema)` to create a new message.
 */
export const GetFDBRequestSchema: GenMessage<GetFDBRequest> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 23);

/**
 * @generated from message poller.v1.GetFDBResponse
 */
export type GetFDBResponse = Message<"poller.v1.GetFDBResponse"> & {
  /**
   * @generated from field: repeated poller.v1.FDBEntry entries = 1;
   */
  entries: FDBEntry[];
};

/**
 * Describes the message poller.v1.GetFDBResponse.
 * Use `create(GetFDBResponseSchema)` to create a new message.
 */
export const GetFDBResponseSchema: GenMessage<GetFDBResponse> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 24);

/**
 * @generated from message poller.v1.FindMACRequest
 */
export type FindMACRequest = Message<"poller.v1.FindMACRequest"> & {
  /**
   * @generated from field: string mac_address = 1;
   */
  macAddress: string;
};

/**
 * Describes the message poller.v1.FindMACRequest.
 * Use `create(FindMACRequestSchema)` to create a new message.
 */
export const FindMACRequestSchema: GenMessage<FindMACRequest> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 25);

/**
 * @generated from message poller.v1.FindMACResponse
 */
export type FindMACResponse = Message<"poller.v1.FindMACResponse"> & {
  /**
   * @generated from field: repeated poller.v1.FindMACResponse.MACLocation locations = 1;
   */
  locations: FindMACResponse_MACLocation[];
};

/**
 * Describes the message poller.v1.FindMACResponse.
 * Use `create(FindMACResponseSchema)` to create a new message.
 */
export const FindMACResponseSchema: GenMessage<FindMACResponse> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 26);

/**
 * @generated from message poller.v1.FindMACResponse.MACLocation
 */
export type FindMACResponse_MACLocation = Message<"poller.v1.FindMACResponse.MACLocation"> & {
  /**
   * @generated from field: int64 device_id = 1;
   */
  deviceId: bigint;

  /**
   * @generated from field: string device_name = 2;
   */
  deviceName: string;

  /**
   * @generated from field: poller.v1.FDBEntry entry = 3;
   */
  entry?: FDBEntry | undefined;
};

/**
 * Describes the message poller.v1.FindMACResponse.MACLocation.
 * Use `create(FindMACResponse_MACLocationSchema)` to create a new message.
 */
export const FindMACResponse_MACLocationSchema: GenMessage<FindMACResponse_MACLocation> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 26, 0);

/**
 * @generated from message poller.v1.ControlInterfaceRequest
 */
export type ControlInterfaceRequest = Message<"poller.v1.ControlInterfaceRequest"> & {
  /**
   * @generated from field: int64 device_id = 1;
   */
  deviceId: bigint;

  /**
   * @generated from field: int32 if_index = 2;
   */
  ifIndex: number;

  /**
   * @generated from field: poller.v1.ControlInterfaceRequest.InterfaceAdminAction action = 3;
   */
  action: ControlInterfaceRequest_InterfaceAdminAction;
};

/**
 * Describes the message poller.v1.ControlInterfaceRequest.
 * Use `create(ControlInterfaceRequestSchema)` to create a new message.
 */
export const ControlInterfaceRequestSchema: GenMessage<ControlInterfaceRequest> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 27);

/**
 * @generated from enum poller.v1.ControlInterfaceRequest.InterfaceAdminAction
 */
export enum ControlInterfaceRequest_InterfaceAdminAction {
  /**
   * @generated from enum value: INTERFACE_ADMIN_ACTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INTERFACE_ADMIN_ACTION_UP = 1;
   */
  UP = 1,

  /**
   * @generated from enum value: INTERFACE_ADMIN_ACTION_DOWN = 2;
   */
  DOWN = 2,
}

/**
 * Describes the enum poller.v1.ControlInterfaceRequest.InterfaceAdminAction.
 */
export const ControlInterfaceRequest_InterfaceAdminActionSchema: GenEnum<ControlInterfaceRequest_InterfaceAdminAction> = /*@__PURE__*/
  enumDesc(file_poller_v1_poller, 27, 0);

/**
 * @generated from message poller.v1.ControlInterfaceResponse
 */
export type ControlInterfaceResponse = Message<"poller.v1.ControlInterfaceResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message poller.v1.ControlInterfaceResponse.
 * Use `create(ControlInterfaceResponseSchema)` to create a new message.
 */
export const ControlInterfaceResponseSchema: GenMessage<ControlInterfaceResponse> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 28);

/**
 * Error message
 *
 * @generated from message poller.v1.PollerError
 */
export type PollerError = Message<"poller.v1.PollerError"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: repeated string traceback = 3;
   */
  traceback: string[];
};

/**
 * Describes the message poller.v1.PollerError.
 * Use `create(PollerErrorSchema)` to create a new message.
 */
export const PollerErrorSchema: GenMessage<PollerError> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 29);

/**
 * @generated from message poller.v1.QueryRadioPeersRequest
 */
export type QueryRadioPeersRequest = Message<"poller.v1.QueryRadioPeersRequest"> & {
  /**
   * @generated from field: poller.v1.PollerDevice device = 1;
   */
  device?: PollerDevice | undefined;
};

/**
 * Describes the message poller.v1.QueryRadioPeersRequest.
 * Use `create(QueryRadioPeersRequestSchema)` to create a new message.
 */
export const QueryRadioPeersRequestSchema: GenMessage<QueryRadioPeersRequest> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 30);

/**
 * @generated from message poller.v1.QueryRadioPeersResponse
 */
export type QueryRadioPeersResponse = Message<"poller.v1.QueryRadioPeersResponse"> & {
  /**
   * @generated from field: poller.v1.PollerResult result = 1;
   */
  result?: PollerResult | undefined;
};

/**
 * Describes the message poller.v1.QueryRadioPeersResponse.
 * Use `create(QueryRadioPeersResponseSchema)` to create a new message.
 */
export const QueryRadioPeersResponseSchema: GenMessage<QueryRadioPeersResponse> = /*@__PURE__*/
  messageDesc(file_poller_v1_poller, 31);

/**
 * Poller Service
 *
 * @generated from service poller.v1.PollerService
 */
export const PollerService: GenService<{
  /**
   * Poll device
   *
   * @generated from rpc poller.v1.PollerService.PollDevice
   */
  pollDevice: {
    methodKind: "unary";
    input: typeof PollDeviceRequestSchema;
    output: typeof PollDeviceResponseSchema;
  },
  /**
   * Poll device with streaming results
   *
   * @generated from rpc poller.v1.PollerService.PollDeviceStream
   */
  pollDeviceStream: {
    methodKind: "server_streaming";
    input: typeof PollDeviceRequestSchema;
    output: typeof PollDeviceResponseSchema;
  },
  /**
   * Get poll results
   *
   * @generated from rpc poller.v1.PollerService.GetPollResults
   */
  getPollResults: {
    methodKind: "unary";
    input: typeof GetPollResultsRequestSchema;
    output: typeof GetPollResultsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_poller_v1_poller, 0);

/**
 * Only on the separately configured mutually authenticated query listener.
 * This service never persists or publishes its result.
 *
 * @generated from service poller.v1.RadioQueryService
 */
export const RadioQueryService: GenService<{
  /**
   * @generated from rpc poller.v1.RadioQueryService.QueryRadioPeers
   */
  queryRadioPeers: {
    methodKind: "unary";
    input: typeof QueryRadioPeersRequestSchema;
    output: typeof QueryRadioPeersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_poller_v1_poller, 1);

